import { cjk } from '@streamdown/cjk';
import { code } from '@streamdown/code';
import { createMathPlugin } from '@streamdown/math';
import { mermaid } from '@streamdown/mermaid';
import remarkGfm from 'remark-gfm';
import type { PluginConfig } from 'streamdown';

/**
 * Shared Streamdown configuration for Nova components.
 *
 * All markdown rendering components should use these shared plugins
 * to ensure consistent rendering across the application.
 *
 * Note: Apps using Nova components must import the required CSS:
 * - `import 'katex/dist/katex.min.css'` for math rendering
 * - `import 'streamdown/styles.css'` for streaming animations
 */

// Configure math plugin — only $$ delimiters for display math
// Single $ is too common in insurance/financial text (e.g. $84,996.65)
export const math = createMathPlugin({ singleDollarTextMath: false });

// All streamdown plugins for full feature support
// Type assertion needed due to unified version mismatch between plugins
export const streamdownPlugins = { cjk, code, math, mermaid } as PluginConfig;

// Shiki theme for syntax highlighting [light, dark]
export const shikiTheme: [string, string] = ['github-light', 'github-dark'];

// Remark plugins for GFM (tables, strikethrough, autolinks, etc.)
export const remarkPlugins = [remarkGfm];
